import styled from 'styled-components';
import { COLORS, THEME_COLORS } from 'variables/theme';

export const Icon = styled.span`
  color: ${COLORS.mediumGrey};
`;
